import React from "react";

export default function Team() {
  return (
    <div id="team">
      <section className="lg:pb-[100px] pb-[50px]">
        <div className="container lg:px-10 px-4">
          <div className="lg:mb-[80px] max-w-[1000px] mx-auto lg:px-10 px-4">
            <h3 className="text-center font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] lg:text-[35px] sm:text-[25px] text-[22px] mb-8">
              Our Team
            </h3>
            <p className="text-center lg:text-[18px] sm:text-[15px] text-[14px] text-center">
              Our team is the driving force behind our success. Comprising
              individuals with diverse backgrounds and passions, they bring
              unique skills and perspectives to the table. Collaborating and
              supporting each other, they are united by a shared drive for
              excellence.
            </p>
          </div>
          <div className="grid lg:grid-cols-2 grid-cols-1 lg:pl-44">
            <div>
              <div className="flex lg:flex-row flex-col lg:text-left text-center gap-3 mt-8 items-center">
                <img
                  src="/assets/team1.png"
                  className="rounded-full lg:h-[180px] h-[100px] lg:w-[180px] w-[100px] object-cover border border-[5px] border-[#751efe]"
                />
                <div>
                  <h3 className="text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] font-bold mb-3">
                    ARTHUR CARMAZZI CEO
                  </h3>
                  <p className="mb-3">CEO</p>
                  <div className="flex lg:justify-start justify-center gap-5">
                    <a className href="javascript:void(0);">
                      <i className="fa-brands fa-facebook-f text-gray-500" />
                    </a>
                    <a className href="javascript:void(0);">
                      <i className="fa-brands fa-twitter text-gray-500" />
                    </a>
                    <a className href="javascript:void(0);">
                      <i className="fa-brands fa-linkedin text-gray-500" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="flex lg:flex-row flex-col lg:text-left text-center gap-3 mt-8 items-center">
                <img
                  src="/assets/team2.png"
                  className="rounded-full lg:h-[180px] h-[100px] lg:w-[180px] w-[100px] object-cover border border-[5px] border-[#751efe]"
                />
                <div>
                  <h3 className="text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] font-bold mb-3">
                    DR. JOHN HUNG
                  </h3>
                  <p className="mb-3">CFO</p>
                  <div className="flex lg:justify-start justify-center gap-5">
                    <a className href="javascript:void(0);">
                      <i className="fa-brands fa-facebook-f text-gray-500" />
                    </a>
                    <a className href="javascript:void(0);">
                      <i className="fa-brands fa-twitter text-gray-500" />
                    </a>
                    <a className href="javascript:void(0);">
                      <i className="fa-brands fa-linkedin text-gray-500" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:mt-0 mt-8">
              <div className="flex lg:flex-row flex-col lg:text-left text-center gap-3 mt-8 items-center">
                <img
                  src="/assets/team3.png"
                  className="rounded-full lg:h-[180px] h-[100px] lg:w-[180px] w-[100px] object-cover border border-[5px] border-[#751efe]"
                />
                <div>
                  <h3 className="text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] font-bold mb-3">
                    LAURENCE k.m. WONG
                  </h3>
                  <p className="mb-3">CTO</p>
                  <div className="flex lg:justify-start justify-center gap-5">
                    <a className href="javascript:void(0);javascript:void(0);">
                      <i className="fa-brands fa-facebook-f text-gray-500" />
                    </a>
                    <a className href="javascript:void(0);javascript:void(0);">
                      <i className="fa-brands fa-twitter text-gray-500" />
                    </a>
                    <a className href="javascript:void(0);javascript:void(0);">
                      <i className="fa-brands fa-linkedin text-gray-500" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="flex lg:flex-row flex-col lg:text-left text-center gap-3 mt-8 items-center">
                <img
                  src="/assets/team4.png"
                  className="rounded-full lg:h-[180px] h-[100px] lg:w-[180px] w-[100px] object-cover border border-[5px] border-[#751efe]"
                />
                <div>
                  <h3 className="text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] font-bold mb-3">
                    CHRISTINA cen
                  </h3>
                  <p className="mb-3">COO</p>
                  <div className="flex lg:justify-start justify-center gap-5">
                    <a className href="javascript:void(0);">
                      <i className="fa-brands fa-facebook-f text-gray-500" />
                    </a>
                    <a className href="javascript:void(0);">
                      <i className="fa-brands fa-twitter text-gray-500" />
                    </a>
                    <a className href="javascript:void(0);">
                      <i className="fa-brands fa-linkedin text-gray-500" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
